import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { styled } from '@mui/material';

export const IconAlignment = styled('div')(() => ({
  display: 'flex',
  gap: '1rem',
}));

export const SwitchCommonPosition = styled('div')(() => ({
  position: 'relative',
  left: '1.4rem',
}));

export const EditOutlinedIconStyle = styled(EditOutlinedIcon)(() => ({
  cursor: 'pointer',
}));
